var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 46,
    viewBox: "0 0 218 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_85_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2907 2.87054V14.5608H11.886L32.2907 24.9757V33.0526V41.1295H24.0013H3.80908V23.0627L11.0358 27.5263H5.08438L15.4993 37.5161L25.9142 27.5263H20.1754L3.80908 12.6478L10.3981 2.87054H20.1754H32.2907Z",
    fill: "url(#paint0_linear_85_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1754 3.12054H32.0407V14.3108H11.886L11.7723 14.7834L32.0407 25.1288V33.0526V40.8795H24.0013H4.05908V23.511L10.1553 27.2763H5.08438H4.46259L4.91132 27.7067L15.3262 37.6965L15.4993 37.8625L15.6724 37.6965L26.0873 27.7067L26.536 27.2763H25.9142H20.272L4.13722 12.6083L10.5311 3.12054H20.1754Z",
    stroke: "#F33B1D",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.101 16.9404V19.1218C205.954 17.8793 207.574 16.6643 210.359 16.6643C214.906 16.6643 217.634 19.7569 217.634 24.2579V27.7371C217.634 31.9619 214.934 35.165 210.416 35.165C207.716 35.165 206.068 34.0053 205.101 32.8455V41.1294H200.81V16.9404H205.101ZM205.101 27.9856C205.3 30.0014 206.551 31.6029 209.165 31.6029C212.064 31.6029 213.229 29.6424 213.229 27.3781V24.4512C213.229 22.2145 212.064 20.2264 209.165 20.2264C206.579 20.2264 205.3 21.8555 205.101 23.8713V27.9856Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.331 34.8889V32.1552C191.882 34.3366 189.466 35.165 186.823 35.165C183.384 35.165 181.31 33.6187 181.31 30.4432C181.31 26.9639 184.407 25.6661 187.164 24.9482L189.182 24.4512C191.654 23.8437 193.217 23.4295 193.217 22.0488V21.9108C193.217 20.9719 192.393 20.1435 190.006 20.1435C187.278 20.1435 186.198 21.1376 186.198 22.822V23.678H181.907V23.1534C181.907 18.9286 184.663 16.6643 189.949 16.6643C195.604 16.6643 197.48 19.039 197.48 22.7115V34.8889H193.331ZM185.601 29.9462C185.601 31.1611 186.425 31.6858 188.159 31.6858C190.83 31.6858 192.848 30.2223 193.217 27.7371V25.6385C192.791 26.6326 191.484 26.9087 189.892 27.4058L188.073 27.8752C186.425 28.3446 185.601 28.8692 185.601 29.9462Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.599 16.9404H157.89L160.931 31.6582L164.17 16.9404H169.712L172.98 31.5753L175.993 16.9404H180.255L175.907 34.8889H170.337L166.927 19.9226L163.432 34.8889H157.947L153.599 16.9404Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.238 35.165C136.588 35.165 133.66 32.4866 133.66 27.4334V26.7707H138.179V27.9856C138.179 30.526 139.657 31.4925 143.323 31.4925C146.364 31.4925 147.699 30.7469 147.699 28.9521V28.4551C147.671 26.6326 146.676 25.9975 143.777 25.3624L139.6 24.2303C136.275 23.2914 134.172 21.4966 134.172 18.1278C134.172 14.0135 137.127 11.8044 142.84 11.8044C148.694 11.8044 151.706 14.1515 151.706 18.4315V19.2323H147.188V18.2659C147.188 16.2501 145.966 15.4493 142.868 15.4493C140.026 15.4493 138.719 16.1397 138.719 17.7136V18.045C138.719 19.5913 139.969 20.3644 142.271 20.8615L146.477 21.966C150.172 22.9048 152.246 24.534 152.246 28.317C152.246 33.0941 149.546 35.165 143.238 35.165Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.993 16.9404V20.5301H126.182V28.814C126.182 30.7745 126.665 31.2992 127.915 31.2992H131.553V34.8889H126.807C122.999 34.8889 121.947 33.0388 121.947 29.6424V20.5301H117.656V16.9404H119.617C121.805 16.7747 122.402 15.118 122.345 12.0805H126.608C126.608 14.4829 126.182 16.5814 124.761 16.9404H135.993Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.08 16.9404V19.6189C106.876 17.8793 108.837 16.6643 111.252 16.6643C114.321 16.6643 116.709 18.3487 116.709 22.822V25.0863H112.332V23.2914C112.332 21.1652 111.565 20.1988 109.661 20.1988C106.961 20.1988 106.08 22.0212 106.08 23.678V34.8889H101.789V16.9404H106.08Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6455 35.165C85.0755 35.165 82.3188 32.0171 82.3188 26.9363V24.893C82.3188 19.8122 85.0755 16.6643 90.6455 16.6643C96.244 16.6643 98.9722 19.8122 98.9722 24.893V26.9363C98.9722 32.0171 96.244 35.165 90.6455 35.165ZM86.6953 27.2953C86.6953 29.8909 87.69 31.6029 90.6455 31.6029C93.6011 31.6029 94.5957 29.8909 94.5957 27.2953V24.534C94.5957 21.966 93.6011 20.2264 90.6455 20.2264C87.69 20.2264 86.6953 21.966 86.6953 24.534V27.2953Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1145 12.0805V19.6465C69.2228 17.9069 71.0416 16.6643 73.6845 16.6643C77.5495 16.6643 79.6809 19.398 79.6809 23.5675V34.8889H75.4181V24.037C75.4181 21.5518 74.3382 20.1987 71.9226 20.1987C69.0807 20.1987 68.2566 22.0488 68.1145 23.5951V34.8889H63.8232V12.0805H68.1145Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0703 35.165C45.4203 35.165 42.4932 32.4866 42.4932 27.4334V26.7707H47.0117V27.9857C47.0117 30.5261 48.4895 31.4925 52.1555 31.4925C55.1963 31.4925 56.532 30.747 56.532 28.9521V28.4551C56.5036 26.6326 55.5089 25.9975 52.6102 25.3624L48.4327 24.2303C45.1077 23.2914 43.0047 21.4966 43.0047 18.1278C43.0047 14.0135 45.9602 11.8044 51.6724 11.8044C57.5266 11.8044 60.539 14.1515 60.539 18.4316V19.2323H56.0205V18.2659C56.0205 16.2501 54.7985 15.4493 51.7008 15.4493C48.8589 15.4493 47.5517 16.1397 47.5517 17.7136V18.045C47.5517 19.5913 48.8021 20.3645 51.104 20.8615L55.31 21.966C59.0044 22.9049 61.079 24.534 61.079 28.317C61.079 33.0941 58.3792 35.165 52.0703 35.165Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_85_27",
    x: 0.809082,
    y: 0.870544,
    width: 34.4817,
    height: 44.2589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_27"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_85_27",
    result: "effect2_dropShadow_85_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_85_27",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.752941 0 0 0 0 0.317647 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_85_27"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823333 0 0 0 0 0.092625 0 0 0 0 0.092625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_85_27",
    result: "effect4_innerShadow_85_27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_27",
    x1: 18.0499,
    y1: 2.87054,
    x2: 18.0499,
    y2: 41.1295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514583,
    stopColor: "#FB6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3A1D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a52b104433b5a72d92e3a2f309e9dfb.svg";
export { ForwardRef as ReactComponent };